import ZeusService from '@/common/services/Zeus';
import {
  getUserSub,
  isUserSessionSetup
} from '@/common/services/account/userSession';

export function persistLocale(locale: string): Promise<unknown> {
  if (isUserSessionSetup()) {
    const userSub = getUserSub();
    return ZeusService.update(`users/${userSub}/personal_information`, {
      default_locale: locale.replace('-', '_')
    });
  }
  return Promise.resolve();
}
